// TODO: подумать
// eslint-disable-next-line boundaries/element-types
import type { Table } from '~shared/api/sanity/types';

export const BlockTable = ({ value }: { value?: Table }) => {
	if (!value || !Array.isArray(value.rows) || value.rows.length === 0) {
		return null;
	}

	const [head, ...rows] = value.rows;

	if (!head || !Array.isArray(head.cells)) {
		return null;
	}

	return (
		<div className="s-portable-text-block-table">
			<table>
				<thead>
					<tr>
						{head.cells.map((cell) => (
							<th key={cell}>{cell}</th>
						))}
					</tr>
				</thead>
				<tbody>
					{rows.map((row, rowIndex) => (
						<tr key={row._key || rowIndex}>
							{Array.isArray(row.cells)
								? row.cells.map((cell, cellIndex) => {
										const Component = cellIndex === 0 ? 'th' : 'td';
										return <Component key={cellIndex}>{cell}</Component>;
								  })
								: null}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
